import ENV from "config/Env";
import { backendQueryKey } from "hooks/useTypedQuery";

import type { Brand, BrandGroup } from "models";

const component = "BrandsDashboard";

export const BrandsDashboardQueryKeys = {
  brands: backendQueryKey<Brand[]>({ component, baseUrl: ENV.carBaseURL, endpoint: "/brands/list" }),
  brandGroups: backendQueryKey<BrandGroup[]>({ component, baseUrl: ENV.carBaseURL, endpoint: "/brands/groups/list" })
};
